import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../../config';
import * as _ from 'lodash';
@Injectable({
  providedIn: 'root'
})
export class JobService {
  private jobSubject = new Subject<any>();
  private getJob = new Subject<any>();
  jobs = [];
  constructor(private http: HttpClient) {
    this.jobs = [];
    console.log('Jobs initialized!!', this.jobs);
  }

  getSingleJob(): Observable<any> {
    return this.getJob.asObservable();
  }

  addJob(data: any): Observable<any> {
    console.log('Adding Jobs', data);
    // let jobData = new FormData();
    // _.forOwn(data, function (value, key) {
    //   jobData.append(key, value)
    // });

    // data['clients'] = clients
    console.log(" For new job data ", data)

    // delete data.client
    // delete data.location

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "jobs", data).subscribe((res: any) => {
        console.log("response of new job created", res);

        observer.next(res.data);
        observer.complete();
      }, err => {
        console.log("ERROR");
        observer.error(err.msg);
      }, () => {
        observer.complete()
      })
    })
  }




  editJobs(data: any, id) {
    console.log("Edit jobs------", data, id);
    Object.assign(data, { _id: id })
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "jobs", data).subscribe((res: any) => {
        console.log("Edited job : ", res);
        observer.next(res.data);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });

  }



  deleteJobs(id) {
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "jobs?_id=" + id).subscribe((res: any) => {
        observer.next(res.data.jobs);
        observer.complete();
      })
    })
  }

  getJobs(): Observable<any> {
    console.log("Getting jobs");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "jobs").subscribe((res: any) => {
        console.log("Get Jobs... :11111111 ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }

  getDashboardCount(): Observable<any> {
    console.log("Getting jobs");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "jobs/count-details").subscribe((res: any) => {
        console.log("Get Jobs... :11111111 ", res);
        observer.next(res);
        observer.complete();
      })
    });
  }

  getSchedularData(data): Observable<any> {
    console.log("data of get display table", data);

    return new Observable<any>((observer) => {
      this.http.put(config.baseApiUrl + "jobs/Schedular", data).subscribe((res: any) => {
        console.log("response of instructores list", res);
        observer.next(res.data)
        observer.complete()
      })
    })
  }

  getJobById(jobId): Observable<any> {
    console.log("Getting jobs", jobId);
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "jobs?jobType=trainer&_id=" + jobId).subscribe((response: any) => {
        console.log("Get Jobs... : ", response.data[0]);
        this.getJob.next(response.data[0])
        observer.next(response);
        observer.complete();
      })
    });
  }
  getJobByInstructorId(instructorId): Observable<any> {
    console.log("Getting jobs");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "jobs/instructor?_id=" + instructorId).subscribe((res: any) => {
        console.log("Get Jobs... : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }
  getJobByClientId(clientId): Observable<any> {
    console.log("Getting jobs");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "jobs/client?_id=" + clientId).subscribe((res: any) => {
        console.log("Get Jobs... : ", res);
        observer.next(res);
        observer.complete();
      })
    });
  }

  getJobUsingLocationId(locationId): Observable<any> {
    console.log("Getting jobs");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "jobs/location?_id=" + locationId).subscribe((res: any) => {
        console.log("Get Jobs... : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }

  getMaterialsUsingJobId(jobId): Observable<any> {
    console.log("Getting MATERIALS");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "jobs/materials?jobId=" + jobId).subscribe((res: any) => {
        console.log("MATERIALS IN SERVICE ARE: ", res);
        observer.next(res.result);
        observer.complete();
      })
    });
  }

  getTrainerJob(): Observable<any> {
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "jobs?jobType=trainer").subscribe((res: any) => {
        console.log("Get Jobs... : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }


  getMpJobById(jobId): Observable<any> {
    console.log("Getting jobs", jobId);
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "jobs?jobType=mp&_id=" + jobId).subscribe((res: any) => {
        console.log("Get Jobs... : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }

  /**
   * *************************************************************
   * archive multiple job update ******************************
   */
  archiveMultipleJobUpdate(obj) {
    console.log("Getting service under obj", obj);
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "jobs/arhicve-multiple-jobs", obj).subscribe((res: any) => {
        console.log("Get Jobs... : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }

  //*******************************
  // multi job delete 
  //******************************************************** */
  multijobDelete(data) {
    console.log("getting job list ======>", data)
  }
  assignmentStatusReport(data) {

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "jobs/assignment-report", data).subscribe((res: any) => {
        console.log("response of new job created", res);

        observer.next(res.data);
        observer.complete();
      }, err => {
        console.log("ERROR");
        observer.error(err.msg);
      }, () => {
        observer.complete()
      })
    })
  }

  sendJobToEditInstructor(jobs) {
    console.log("response of jobs ", jobs);

    this.jobSubject.next({ jobs })
  }
  getJobFromJobsComponent(): Observable<any> {
    return this.jobSubject.asObservable();
  }


  getMailList() {
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "jobs/mailQue").subscribe((res: any) => {
        console.log("Get Jobs... : ", res);
        observer.next(res);
        observer.complete();
      })
    });
  }

  generateSamples(jobId) {
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "jobs/generate-samples", jobId).subscribe((res: any) => {
        console.log("response of generated samples", res);
        observer.next(res);
        observer.complete();
      }, err => {
        console.log("ERROR");
        observer.error(err.msg);
      }, () => {
        observer.complete()
      })
    })
  }

  updateSequence(data: any): Observable<any> {
    console.log("Edit courses", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "jobs/quiz-list", data).subscribe((res: any) => {
        console.log("Edited Course : ", res);
        observer.next(res);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });

  }

}
